const BASE_URL = window.location.origin;
export const NOTIFICATION_ENDPOINT = `${BASE_URL}/auto/sow/kreditz/notification?caseId=`;

export const USER_FLOW_COMPLETED = {
	status: 'success',
	userFlowCompleted: 'User flow completed',
	bankingAuthStarted: 'banking authentication started',
	bankingAuthFinished: 'banking authentication finished'
};

export const COMPLETED = 'completed';
export const FAILED = 'failed';

export const NOTIFICATION_ID = 'spending-limit';
